import React from "react";
import {useTranslation} from "react-i18next";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/tr_TR";
const {RangePicker} = DatePicker;

const DateRangeFilter = ({value, onChange, showLabel = true, label}) => {
    const {t} = useTranslation();
    return (
        <React.Fragment>
            {showLabel && <h5>{label || `Tarih Aralığı`}</h5>}
            <RangePicker
                style={{width: "100%"}}
                locale={locale}
                value={value}
                format={"DD.MM.YYYY"}
                onChange={dates => onChange(dates)}
            />
        </React.Fragment>
    );
};

export default DateRangeFilter;
